<template>
    <v-container>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="3" class="yellow lighten-4 font-weight-bold">{{ getUndanganName() }}</v-col>
                    <v-col v-if="undangan != null && undangan.fileUndangan !== ''">
                        <v-btn icon @click="tenderLib.getFileDownloadLink(paket.id, `FileUndangan_${undangan.tipe}_${undangan.vendorId}`, undangan.fileUndangan, false)"><v-icon color="green">get_app</v-icon></v-btn>
                        {{ undangan.fileUndangan }}
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>


<script>

import { TenderLib } from "./../../lib/tenderLib";

export default {
    props: {
        undangan: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            tenderLib: TenderLib,
        }
    },

    computed: {
        paket() {
            return this.$store.getters['lelang/paket'];
        },
    },

    watch: {
        paket() {

        }
    },
    methods: {
        getUndanganName() { 
            const tipe = this.undangan.tipe;

            switch (tipe) 
            {
                case 'P': return "Undangan Peserta";
                case 'B': return "Undangan Pembuktian Kualifikasi";
                case 'B2': return "Undangan Pembuktian Administrasi dan Teknis";
                case 'L': return "Undangan Tender";
                case 'N': return "Undangan Negosiasi";
            }

            return "";
        }
    }
}

</script>
